export const locale = {
  lang: 'fr-CA',
  data: {
    UPGRADE_REQUEST: {
      TITLE: 'Demander une mise à niveau',
      INTRO:
        'Dites-nous ce qui vous intéresse et laissez-nous un message : notre équipe vous contactera pour passer au forfait PRO.',
      INTERESTED_IN: 'Nous sommes intéressés à :',
      INTEREST_SUBMISSIONS: 'Soumission Web',
      INTEREST_AUTOMATIONS: 'Automatisations',
      INTEREST_INTEGRATIONS: 'Intégrations',
      MESSAGE: 'Message',
      MESSAGE_PLACEHOLDER:
        'Vos besoins, vos questions, le meilleur moment pour vous joindre…',
      SEND: 'Envoyer',
      SENT_TOAST: 'Demande envoyée. Merci !',
      SENT_TITLE: 'Demande envoyée',
      SENT_TEXT:
        'Merci ! Notre équipe a reçu votre demande et vous contactera sous peu.',
      SEND_ANOTHER: 'Envoyer une autre demande',
    },
  },
};
